import * as yup from 'yup'


const initialTransactionDetails = {
	logisticsBeforeTax: "",
	logisticsHSNCode: null,
	logisticsTDSSection: "",
	logisticsTDSValue: null,
	tdsSectionId: null,
    PMState: "",
    expenseCategoryId: ""
}

const AddExpenseSchema = yup.object().shape({
    PMState: yup.string().required('This Field is required').trim(),
    expenseCategoryId : yup.string().required('This Field is required').trim(),
})



const AddExpenseProductsSchema = yup.array().of(
    yup.object().shape({
        HSNCode : yup.number().transform(value => (value) ? parseInt(value) : null).nullable().required('This Field is required'),
        unitPrice : yup.number().transform(value => (value) ? parseInt(value) : null).nullable().required('This Field is required'),
        qty : yup.number().transform(value => (value) ? parseInt(value) : null).nullable().required('This Field is required'),
    })
)


export { AddExpenseSchema, AddExpenseProductsSchema, initialTransactionDetails }
